import api from '@/utils/api';

const state = {
  task_pagination: {
    cn: 1,
    sn: 20,
    offset: 0
  }
};
const mutations = {};

const getters = {};
const actions = {
  // 获取提醒/质询列表
  async api_list_reminders_inquiries(_commit, params) {
    return api.post('/api/task/listRemindersAndInquiries', params);
  },
  async api_list_reminders_inquiries_by_creator(_commit, params) {
    return api.post('/api/task/listRemindersAndInquiriesByCreator', params);
  },
  async api_list_statement(_commit, params) {
    return api.post('/api/task/listStatement', params);
  },
  async api_query_reminders_inquiries_by_id(_commit, params) {
    return api.get('/api/task/queryRemindersAndInquiries', {params: params});
  },
  async api_update_reminders_inquiries(_commit, params) {
    return api.post('/api/task/updateRemindersAndInquiriesAlerted', params);
  },
  async api_query_statement_by_id(_commit, params) {
    return api.get('/api/task/queryStatement', {params: params});
  },
  async api_query_blocking_reminders(_commit, params) {
    return api.get('/api/task/listRemindersCauseBlocking', {params: params});
  },
  async api_query_reminders_log(_commit, params) {
    return api.get('/api/task/queryReminderLog', {params: params, hideErrorMessage: true});
  },
  async api_add_reminders_cc(_commit, params) {
    return api.post('/api/task/addReminderCc', params);
  },
  async api_query_principals(_commit, params) {
    return api.post('/api/task/queryStaffByOrg', params);
  },
  async api_change_supervisor(_commit, params) {
    return api.post('/api/task/changeSupervisor', params);
  },
  async api_check_task_vp(_commit, params) {
    return api.post('/api/task/checkVP', params);
  },
};

export default {
  state,
  mutations,
  getters,
  actions
};
